// ERP Attribute Engine — Condition Evaluator

function isConditionGroup(when) {
  return 'all' in when || 'any' in when;
}

function evalSingle(cond, values) {
  const v = values[cond.field];
  switch (cond.operator) {
    case 'eq':       return v === cond.value;
    case 'neq':      return v !== cond.value;
    case 'gt':       return typeof v === 'number' && v > cond.value;
    case 'lt':       return typeof v === 'number' && v < cond.value;
    case 'gte':      return typeof v === 'number' && v >= cond.value;
    case 'lte':      return typeof v === 'number' && v <= cond.value;
    case 'in':       return Array.isArray(cond.value) && cond.value.includes(v);
    case 'nin':      return Array.isArray(cond.value) && !cond.value.includes(v);
    case 'empty':    return v === undefined || v === null || v === '' || (Array.isArray(v) && v.length === 0);
    case 'notEmpty': return v !== undefined && v !== null && v !== '' && !(Array.isArray(v) && v.length === 0);
    case 'contains':
      if (typeof v === 'string') return v.includes(String(cond.value));
      if (Array.isArray(v)) return v.includes(cond.value);
      return false;
    default: return false;
  }
}

function evalWhen(when, values) {
  if (isConditionGroup(when)) {
    if (when.all) return when.all.every(c => evalSingle(c, values));
    if (when.any) return when.any.some(c => evalSingle(c, values));
    return false;
  }
  return evalSingle(when, values);
}

export function evaluateConditionalRules(rules, values) {
  const hidden = new Set();
  const disabled = new Set();
  const requiredOverrides = new Set();
  const unrequiredOverrides = new Set();

  for (const rule of rules) {
    if (!evalWhen(rule.when, values)) continue;
    rule.then.show?.forEach(id => hidden.delete(id));
    rule.then.hide?.forEach(id => hidden.add(id));
    rule.then.enable?.forEach(id => disabled.delete(id));
    rule.then.disable?.forEach(id => disabled.add(id));
    rule.then.require?.forEach(id => {
      requiredOverrides.add(id);
      unrequiredOverrides.delete(id);
    });
    rule.then.unrequire?.forEach(id => {
      unrequiredOverrides.add(id);
      requiredOverrides.delete(id);
    });
  }

  return { hidden, disabled, requiredOverrides, unrequiredOverrides };
}
